import React from "react";
import PropTypes from "prop-types";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import { compose } from 'recompose';
// core components
var firebase = require("firebase");
var firebaseui = require("firebaseui");
import { connect } from 'react-redux';
import * as types from 'src/types';
import * as actions from '../../reducers/action-reducer'
import { AppSection } from "src/types";
// core components
import GridContainer from "../../components/Grid/GridContainer";
import GridItem from "../../components/Grid/GridItem";
import Card from "../../components/Card/Card";
import CardBody from "../../components/Card/CardBody";
import CardHeader from "../../components/Card/CardHeader";
import loginPageStyle from "../../assets/jss/material-dashboard-pro-react/views/loginPageStyle";

interface ILoggingInProps {
    classes: any;
    connect: types.IState;
}
interface ILoggingInState {

}
class LoggingIn extends React.Component<ILoggingInProps, ILoggingInState> {
    constructor(props: ILoggingInProps) {
        super(props);
        // we use this to make the card to appear after the page has been rendered
        this.state = {

        };
    }
    timeOutFunction: any;
    ui: any;
    componentDidMount() {

    }

    redirected:boolean = false;
    render() {
        const { classes } = this.props;

        if (!this.redirected && this.props.connect.lo_CustomerBalance.completed() && this.props.connect.lo_ctx.completed() ){
               
              setTimeout(()=>{
                  types.ViewState.navigate(types.ViewState.getDefaultHash(types.AppSection.Discovery));
              },1);
               this.redirected = true;
           }
        return (
            <div className={classes.container}>
            <GridContainer justify="center">
              <GridItem xs={12} sm={6} md={4}>
                <form>
                  
                </form>
              </GridItem>
            </GridContainer>
          </div>
      
        );
    }
}


LoggingIn['propTypes'] = {
    classes: PropTypes.object.isRequired
};

export function mapStateToProps(state: types.IState) {
    //withStyles(loginPageStyle)(LoginPage)
    return {
        connect: state

    }



}
/*
export function mapDispatchToProps(dispatch: Dispatch<actions.EnthusiasmAction>) {
  return {
    onIncrement: () => dispatch(actions.incrementEnthusiasm()),
    onDecrement: () => dispatch(actions.decrementEnthusiasm()),
  }
}*/

//export default connect(mapStateToProps, mapDispatchToProps)(Hello);

export default compose(
    //@ts-ignore
    withStyles(loginPageStyle),
    connect(mapStateToProps, null)
)(LoggingIn);
//export default connect(mapStateToProps,null, withStyles(loginPageStyle)(LoginPage));



// WEBPACK FOOTER //
// ./src/views/pages/LoggingIn.tsx